<table mat-table [dataSource]="documentos" class="w-full table-auto" *ngIf="documentos">
    <!-- tipoDocumento Column -->
    <ng-container matColumnDef="tipoDocumento">
        <td mat-cell *matCellDef="let doc" >
            <div class="flex gap-2 items-center cursor-pointer" (click)="mostrarArchivoDrawer(doc)">
                <div
                    class="flex h-full"
                >
                    <!-- Icons -->
                    <div class="relative">
                        <mat-icon
                            class="text-hint opacity-50 icon-size-8"
                            [svgIcon]="
                                'heroicons_solid:document'
                            "
                        ></mat-icon>
                        <div
                            class="absolute bottom-0 left-0 rounded px-1 text-xs font-semibold leading-5 text-white bg-red-600"
                        >
                            PDF
                        </div>
                    </div>
                </div>
                <span class="font-medium leading-5">{{doc.nombre}}</span>
                <span  class="px-2 rounded-full text-sm font-bold text-white"
                [ngStyle]="{
                    'background-color': doc.estado.valor1, 
                }">
                    {{doc.estado.descripcion}}
                </span>
            </div>
        </td>
    </ng-container>

    <!-- Generado Por Column -->
    <ng-container matColumnDef="generadoPor">
        <td mat-cell *matCellDef="let doc">Generado {{doc.fechaInicioVigencia | date: 'mediumDate'}} por {{doc.generadoPor}}</td>
    </ng-container>

    <!-- Descargar Column -->
    <ng-container matColumnDef="descargar">
        <td mat-cell *matCellDef="let doc" >
            <div class="w-full flex justify-end">
                
            </div>  
            <button matButton [matMenuTriggerFor]="menu"> <mat-icon>more_vert</mat-icon></button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="downloadFile(doc)">
                    <mat-icon
                        [svgIcon]="'heroicons_solid:cloud-arrow-down'">
                    </mat-icon>
                    Descargar
                </button>
                <button mat-menu-item (click)="mostrarArchivoDrawer(doc)">
                    <mat-icon
                        [svgIcon]="'heroicons_solid:eye'">
                    </mat-icon>
                    Vizualizar Documento
                </button>
                <button mat-menu-item (click)="verDetalleDocumento(doc.documentoGeneradoUuid)">
                    <mat-icon
                        [svgIcon]="'heroicons_solid:document-text'">
                    </mat-icon>
                    Ver Detalle
                </button>
                @if(doc.estado.tipologiaId != idEstaoCertificado){
                    <button mat-menu-item
                        *hasPermissions="'certificar_documento_emitido'; modulos ['EmitirDocumento']"  
                        (click)="certificarDocumento(doc)">
                        <mat-icon
                            [svgIcon]="'heroicons_solid:document-check'">
                        </mat-icon>
                        Certificar Documentos</button>
                    <button mat-menu-item 
                        *hasPermissions="'borrar_documento_emitido'; modulos ['DocumentoEmitido']"
                        (click)="eliminarDocumento(doc)">
                        <mat-icon
                            [svgIcon]="'heroicons_solid:trash'">
                        </mat-icon>
                        Borrar Documentos</button>
                }
                
            </mat-menu>
        </td>
    </ng-container>

    
    <tr mat-row *matRowDef="let row; columns: ['tipoDocumento', 'generadoPor', 'descargar']" class="border-b"></tr>
</table>

<div *ngIf="documentos.length === 0" class="p-4 text-center text-gray-500">
  No hay datos para mostrar.
  <!--<button (click)="mostrarArchivoDrawer()">Button</button>-->
</div>